import { BaseEntryDto } from "ts-types/api.types";

/**
 * TARMED procedure type (column `leistung_typ`) of a reference procedure ("Referenzleistung").
 * Such a procedure can only be billed as a descendant of one of its master procedures.
 */
export const TARMED_REFERENCE_PROCEDURE_TYPE = "R";

export const isReferenceProcedure = (entry?: Partial<BaseEntryDto>): boolean => {
  return !!entry && !!entry.tarmedProcedure && entry.tarmedType == TARMED_REFERENCE_PROCEDURE_TYPE;
};
